"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerId = void 0;
var RequestShoppingContext = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ShoppingContextLoadedEvent = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _auth = require("@ori/auth");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const useCustomerId = ({
  shouldLoadContext
}) => {
  const [customerId, setCustomerId] = (0, _react.useState)(_auth.NOT_LOGGED_IN_USER_ID);
  const [loading, setLoading] = (0, _react.useState)(false);
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const onContextLoaded = (0, _react.useCallback)(event => {
    setCustomerId(event.detail.customerId);
    setLoading(false);
  }, []);
  const events = (0, _react.useMemo)(() => [{
    name: ShoppingContextLoadedEvent.Name,
    listener: onContextLoaded
  }], [onContextLoaded]);
  (0, _presentationHooks.useGlobalEvents)(events);
  (0, _react.useEffect)(() => {
    if (!isAnonymousUser && isUserVerified && shouldLoadContext) {
      window.dispatchEvent(new CustomEvent(RequestShoppingContext.Name));
      setLoading(true);
    }
  }, [isAnonymousUser, isUserVerified, shouldLoadContext]);
  return {
    customerId,
    loading: !isUserVerified || loading
  };
};
exports.useCustomerId = useCustomerId;